import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface PageHeaderProps {
    title: string;
    /** Meta line under the title, e.g. "Riverside · 14 open". */
    meta?: ReactNode;
    /** Detail and form pages only. */
    back?: { to: string; label: string };
    /** Buttons, right-aligned from 640 px, stacked below. At most one primary. */
    actions?: ReactNode;
    /** Tabs or filters row. */
    children?: ReactNode;
}

/** The one h1 of a page. The page container (padding, max width) comes from Layout. */
export const PageHeader = ({ title, meta, back, actions, children }: PageHeaderProps) => (
    <header className="mb-6">
        {back && (
            <Link
                to={back.to}
                className="-ml-1 mb-1 inline-flex min-h-control items-center gap-1 rounded-control px-1 text-small text-link"
            >
                <ChevronLeftIcon className="size-5" aria-hidden="true" />
                {back.label}
            </Link>
        )}
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
            <div className="min-w-0">
                <h1 className="font-display text-display-sm text-strong sm:text-display">{title}</h1>
                {meta && <p className="mt-1 text-small text-muted">{meta}</p>}
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2 sm:justify-end">{actions}</div>}
        </div>
        {children && <div className="mt-4">{children}</div>}
    </header>
);
